module.exports = __webpack_public_path__ + "static/media/shopnow.fb5ab64a.png";